import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  priority: {
    alignItems: 'center',
    borderRadius: '0.25rem',
    color: theme.vars.palette.common.white,
    display: 'flex',
    fontSize: '0.65rem',
    fontWeight: 700,
    height: '1.1rem',
    justifyContent: 'center',
    minWidth: '1rem',
    padding: '0.50rem !important',
    margin: 'auto',
    '@container (max-width: 150px)': {
      fontSize: '0.6rem',
      height: '1rem'
    },
    '@container (min-width: 151px)': {
      fontSize: '0.6rem',
      height: '1.25rem',
      width: '1.25rem'
    },
    '@container (min-width: 300px)': {
      fontSize: '1rem',
      height: '2rem',
      width: '2rem'
    },
    '@container (min-width: 400px)': {
      fontSize: '1.5rem',
      height: '2.5rem',
      width: '2.5rem'
    }
  },
  prioritiesContainer: {
    marginRight: '1rem',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(1)
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: `${theme.spacing(1)}!important`
    }
  },
  timeDisplay: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.75rem',
    '@container (max-width: 150px)': {
      fontSize: '0.5rem'
    },
    '@container (min-width: 151px)': {
      fontSize: '0.75rem'
    },
    '@container (min-width: 300px)': {
      fontSize: '1rem'
    },
    '@container (min-width: 400px)': {
      fontSize: '1.25rem'
    }
  },
  unitsDisplay: {
    fontSize: '0.5rem',
    marginTop: '-0.25rem',
    '@container (max-width: 150px)': {
      fontSize: '0.4rem'
    },
    '@container (min-width: 151px)': {
      fontSize: '0.75rem'
    },
    '@container (min-width: 300px)': {
      fontSize: '1rem'
    }
  }
}));

export default useStyles;
